import { createContext, useState, useEffect } from "react";
import http from "../components/services/utility";
// import { useTranslation } from "react-i18next";

// Create a context
const AuthContext = createContext({});

// eslint-disable-next-line react/prop-types
const AuthProvider = ({ children }) => {
    //   const { t, i18n } = useTranslation();
    const [auth, setAuthState] = useState("");
    const [candidateAuth, setCandidateAuthState] = useState("");
    const [lang, setLang] = useState("");

    const [isTableLoading, setIsTableLoading] = useState(false)
    const [masterData, setMasterData] = useState({})

    const [toastState, setToastState] = useState({
        open: false,
        msg: '',
        vertical: 'center',
        horizontal: 'center',
        seconds: 3000
    })

    const [isRoutesOpen, setIsRoutesOpen] = useState({
        isAppOpen: true,
        isObjectionOpen: false,
        isAdmitCardOpen: false,
        isEditAppOpen: false
    });

    const [alertState, setAlertState] = useState({
        open: false,
        title: '',
        isSessionExpire: false,
        btnTxt: '',
        status: 'success'
    })

    const [isLoading, setIsLoading] = useState(false)

    // Change Language
    //   useEffect(() => {
    //     if (lang !== "") {
    //       i18n.changeLanguage(lang);
    //     }
    //   }, [lang]);

    const setLanguage = async (code) => {
        await localStorage.setItem("lang", code);
        setLang(code);
    };

    // Get current auth state from localStorage
    const getLanguage = async () => {
        try {
            const authDataString = await localStorage.getItem("lang");
            // console.log("authDataString", authDataString);
            if (authDataString) {
                setLang(authDataString);
            }
        } catch (err) {
            setLang("en");
        }
    };

    // Get current auth state from localStorage
    const getAuthState = async () => {
        try {
            const authDataString = await (localStorage.getItem("admin-token") || 'logout');
            // console.log('authDataString :>> ', authDataString);
            const authData = JSON.parse(authDataString);
            setAuthState(authData);
        } catch (err) {
            setAuthState("logout");
        }
    };
    const getCandidateAuthState = async () => {
        try {
            const authDataString = await localStorage.getItem("app-token");
            // console.log('candidate :>> ', authDataString);
            const authData = JSON.parse(authDataString);
            setCandidateAuthState(authData);
        } catch (err) {
            setCandidateAuthState("");
        }
    };

    const deleteAuthState = async (auth, user) => {
        try {
            await localStorage.removeItem(auth);
            // await localStorage.removeItem(user);
            // await localStorage.removeItem("disclaimer");
            // await localStorage.removeItem("userjourney");
            if (auth === 'admin-token') {
                setAuthState("logout");
            }
            else {
                sessionStorage.removeItem('expiresAt')
                setCandidateAuthState("")
            }
            // setDisclaimerState("");
            // setUserJourneyState("");
        } catch (err) {
            if (auth === 'admin-token') {
                setAuthState("logout");
            }
            else {
                setCandidateAuthState("")
            }
        }
    };
    const setAuth = async (key, auth) => {
        try {
            let date = new Date();
            date.setTime(date.getTime() + 1);
            const options = { path: "/", expires: date };
            await localStorage.setItem(key, JSON.stringify(auth), options);
            if (key === 'admin-token') {
                setAuthState(auth);
            }
            else {
                setCandidateAuthState(auth)
            }
        } catch (error) {
            Promise.reject(error);
        }
    };
    const setUser = async (key, user) => {
        try {
            await localStorage.setItem(key, user);
        } catch (error) {
            Promise.reject(error);
        }
    };

    const getMasterData = (path, masterType) => {
        http
            .get(path)
            .then((res) => {
                setMasterData((previousState) => ({
                    ...previousState,
                    [masterType]: res?.data?.data,
                }));
            })
            .catch((err) => {
                setAlertState((prev) => ({
                    ...prev,
                    open: true,
                    title: err?.response?.data?.msg,
                    btnTxt: "CLOSE",
                    status: "fail",
                }));
            });
    };

    useEffect(() => {
        (async () => {
            await getAuthState();
            await getCandidateAuthState();
            await getLanguage();
        })();
    }, []);

    return (
        <AuthContext.Provider
            value={{
                auth,
                candidateAuth,
                setAuth,
                deleteAuthState,
                setLanguage,
                setUser,
                lang,
                toastState,
                setToastState,
                isLoading,
                setIsLoading,
                alertState,
                setAlertState,
                isTableLoading,
                setIsTableLoading,
                masterData,
                setMasterData,
                getMasterData,
                isRoutesOpen,
                setIsRoutesOpen
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthProvider };
